module.exports = __webpack_public_path__ + "img/ElCamino1975300x300.07993a53.jpg";